import { render } from "./TextPage.vue?vue&type=template&id=0df251b0&scoped=true"
import script from "./TextPage.vue?vue&type=script&lang=js"
export * from "./TextPage.vue?vue&type=script&lang=js"

import "./TextPage.vue?vue&type=style&index=0&id=0df251b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df251b0"]])

export default __exports__